/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationPolicyCreateNameMax = 120;

export const notificationPolicyCreateStepsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyCreateStepsItemPositionMin = 0;
export const notificationPolicyCreateStepsItemPositionMax = 9007199254740991;

export const notificationPolicyCreateStepsItemDelayMinutesMin = 0;
export const notificationPolicyCreateStepsItemDelayMinutesMax = 1440;

export const notificationPolicyCreateStepsItemTargetOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyCreateStepsItemTargetTwoScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyCreateStepsItemTargetThreeTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyCreateStepsItemChannelsMax = 3;

export const NotificationPolicyCreate = zod.object({
  name: zod.string().min(1).max(notificationPolicyCreateNameMax),
  enabled: zod.boolean(),
  steps: zod
    .array(
      zod.object({
        id: zod.uuid().regex(notificationPolicyCreateStepsItemIdRegExp),
        position: zod
          .int()
          .min(notificationPolicyCreateStepsItemPositionMin)
          .max(notificationPolicyCreateStepsItemPositionMax),
        delayMinutes: zod
          .int()
          .min(notificationPolicyCreateStepsItemDelayMinutesMin)
          .max(notificationPolicyCreateStepsItemDelayMinutesMax),
        condition: zod.enum(['not-acknowledged', 'not-resolved']),
        target: zod.union([
          zod.object({
            kind: zod.literal('user'),
            userId: zod.uuid().regex(notificationPolicyCreateStepsItemTargetOneUserIdRegExp),
          }),
          zod.object({
            kind: zod.literal('schedule'),
            scheduleId: zod
              .uuid()
              .regex(notificationPolicyCreateStepsItemTargetTwoScheduleIdRegExp),
          }),
          zod.object({
            kind: zod.literal('team'),
            teamId: zod.uuid().regex(notificationPolicyCreateStepsItemTargetThreeTeamIdRegExp),
          }),
        ]),
        channels: zod
          .array(zod.enum(['email', 'sms', 'voice']))
          .min(1)
          .max(notificationPolicyCreateStepsItemChannelsMax),
      }),
    )
    .min(1),
});

export type NotificationPolicyCreate = zod.input<typeof NotificationPolicyCreate>;
export type NotificationPolicyCreateOutput = zod.output<typeof NotificationPolicyCreate>;
